import React, { useState, useRef, useEffect } from 'react';
import { networks } from '../networks';
import './NetworkSwitcher.css';

const NetworkSwitcher = ({ selectedNetwork, setSelectedNetwork, isDisabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const handleNetworkChange = (networkKey) => {
    setSelectedNetwork(networkKey);
    setIsOpen(false);
  };

  const selectedNetworkData = networks[selectedNetwork];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <div className="network-switcher" ref={ref} data-is-open={isOpen}>
      {selectedNetworkData ? (
        <div className="selected-network-info" onClick={() => setIsOpen(!isOpen)}>
          <img src={selectedNetworkData.logo} alt={selectedNetworkData.chainName} className="network-logo" />
          <span>{selectedNetworkData.chainName}</span>
          <span className="dropdown-arrow"></span>
        </div>
      ) : (
        <button onClick={() => setIsOpen(!isOpen)} disabled={isDisabled} className="network-switcher-button">
          Select Network
          <span className="dropdown-arrow"></span>
        </button>
      )}
      {isOpen && (
        <ul className="network-list">
          {Object.keys(networks).map((networkKey) => (
            <li key={networkKey} onClick={() => handleNetworkChange(networkKey)}>
              <img src={networks[networkKey].logo} alt={networks[networkKey].chainName} className="network-logo" />
              {networks[networkKey].chainName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NetworkSwitcher;